// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e7410c93","239":"29100132","349":"2a03a597","354":"25f30458","521":"cc474cfe","538":"1dd6dc51","555":"d660b6f4","610":"fd7e90c0","806":"e96e5ac0","813":"821c0463","963":"a3cf845b","988":"6d65db6a"}[chunkId] + ".chunk.js";
};